import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "navbar-brand d-flex align-items-center",
  href: "#"
}
const _hoisted_2 = ["src"]

import { computed, ref } from "vue";
import logo from "../../assets/logo.png";
import ToggleThemeButton from "../ToggleThemeButton.vue";
import NavbarLinks from "./NavbarLinks.vue";
import MobileModalDropDown from "../MobileModalDropDown.vue";
import { ThemeType, useGlobalStore } from "@/stores/GlobalStore";
// import globalState, { ThemeType } from "@/globals/state";


export default /*@__PURE__*/_defineComponent({
  __name: 'Navbar',
  props: {
    theme: {}
  },
  setup(__props: any) {

const props = __props;
const globalStore = useGlobalStore();

const containerClass = computed(() => {
  return `navbar-${props.theme} ${globalStore.bgThemeClass}`;
});
const mobileComputed = computed(() => {
  return props.theme === "dark" ? "dark-theme-shadow" : "light-theme-shadow";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(["navbar navbar-expand-lg p-3 z-10 col-12 sticky opacity-100 px-md-4 w-100", containerClass.value])
  }, [
    _createElementVNode("a", _hoisted_1, [
      _createElementVNode("img", {
        src: _unref(logo),
        alt: "Vue Logo",
        style: {"height":"40px"}
      }, null, 8, _hoisted_2),
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "ms-2" }, "Vue App", -1))
    ]),
    _createElementVNode("button", {
      class: _normalizeClass(["mr-3", 
        _unref(globalStore).useGradient
          ? 'text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-purple-500'
          : 'line-through text-gray-500'
      ]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(globalStore).toggleUseGradient && _unref(globalStore).toggleUseGradient(...args)))
    }, " Gradient ", 2),
    _createVNode(ToggleThemeButton, {
      theme: _ctx.theme,
      "class-name": "me-auto"
    }, null, 8, ["theme"]),
    (!_unref(globalStore).isMobile)
      ? (_openBlock(), _createBlock(NavbarLinks, {
          key: 0,
          className: "d-flex flex-row gap-2"
        }))
      : _createCommentVNode("", true),
    (_unref(globalStore).isMobile)
      ? (_openBlock(), _createBlock(MobileModalDropDown, {
          key: 1,
          childClass: `${_unref(globalStore).bgThemeClass} px-3 pb-3 pt-1   position-absolute childClass ${mobileComputed.value}`,
          parentClass: `parentClass position-absolute z-10  bg-black bg-opacity-50`,
          class: ""
        }, {
          default: _withCtx(() => [
            _createVNode(NavbarLinks)
          ]),
          _: 1
        }, 8, ["childClass"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})